import * as Lucide from "lucide-react";

export function Icon({ name, className }) {
  const Cmp = Lucide[name] || Lucide.Store;
  return <Cmp className={className} />;
}
